import React from 'react';
import Form from 'react-bootstrap/Form';
import Stack from 'react-bootstrap/Stack';
import { DataContext } from './DataContextProvider.js';

export default function SelectMetric({ changeMetric, withCount, toggleNone, name }) {
  const dataContext = React.useContext(DataContext);
  const onChangeMetric = event => {
    sessionStorage.setItem(name + 'Metric', event.target.value);
    changeMetric(parseInt(event.target.value));
  }

  let selectedMetric = sessionStorage.getItem(name + 'Metric') || '3';

  React.useEffect(() => { changeMetric(parseInt(selectedMetric)); }, [changeMetric, selectedMetric]);

  return (
    <Form>
      <Stack direction="horizontal">
        <Form.Control as="select" size="sm" defaultValue={selectedMetric} onChange={onChangeMetric} style={{width: 'auto'}}>
          {withCount && <option value="9">Posts</option>}
          <option value="3">Page views</option>
          <option value="4">Organic views</option>
          <option value="5">Direct views</option>
          <option value="6">Paid views</option>
          <option value="2">Sessions</option>
          <option value="1">Users</option>
          <option value="7">Signups</option>
          <option value="8">Conversion Rate</option>
        </Form.Control>
        {toggleNone &&
          <>
            &nbsp;
            <Form.Check label={`Remove "${toggleNone}" from chart`} checked={dataContext.ignoreNone} onChange={dataContext.toggleNone} />
          </>
        }
      </Stack>
    </Form>
  );   
}
